// js for header nav
const drawer = document.querySelector('.menu-drawer__menu');

drawer.querySelectorAll('.menu-drawer__menu-container')
  .forEach((detail) => {

    detail.addEventListener('toggle', function () {

      if (detail.open) {
        drawer
          .querySelectorAll('.menu-drawer__menu-container')
          .forEach((other) => {
            if (other !== detail) other.removeAttribute('open');
          });
      }

    });

  });

// js for home page by style slider
$('.multiple-items').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
        {
        breakpoint: 1025,
        settings: {
            rows: 2,
            slidesPerRow: 2,
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: true
        }
        },
        {
        breakpoint: 600,
        settings: {
            rows: 2,
            slidesPerRow: 2,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
        }
        }
    ]
});